var l10n = require('diy/util/l10n');

diy.angular.registerFactory('diyl10n', [function() { return l10n.getString; }]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/services/diyl10n.js
 ** module id = 881
 ** module chunks = 0
 **/